import { BREAK_POINT_PC } from './constants';

export default function isSmartPhone() {
  return window.innerWidth < BREAK_POINT_PC;
}
